import { Box, Container } from '@arquivei/atenas';
import { CssBaseline } from '@mui/material';
import Head from 'next/head';

import Header from '../components/Header/Header';
import Faq from '../components/Help/Faq/Faq';
import HelpStart from '../components/Help/HelpStart';
import Support from '../components/Help/Support';
import Layout from '../components/Layout';

const HelpPage = () => {
  return (
    <Layout>
      <Head>
        <title>Central de ajuda</title>
      </Head>
      <CssBaseline />

      <Header />

      <Box
        sx={{
          minHeight: '60vh',
          position: 'relative',
        }}
      >
        <Container maxWidth="xl">
          <Support />
        </Container>
      </Box>

      <Box
        sx={{
          minHeight: '75vh',
          position: 'relative',
          pb: 22,
        }}
      >
        <Container maxWidth="xl">
          <HelpStart />
        </Container>
      </Box>

      <Box sx={{ backgroundColor: 'neutral.50', pb: 14 }}>
        <Container maxWidth="xl">
          <Faq />
        </Container>
      </Box>
    </Layout>
  );
};

export default HelpPage;
